import { SearchFormInputs } from "../../constants";
import { BackArrowIcon, EditIcon, NextArrowIcon, PassengerIcon, SearchIcon } from "src/assets/Icons";
import { perpareSeachObjectChipValues } from "./utils";
import { explode } from "src/utility/objects";
import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";

const JourneyChip: FC<{ searchObject: SearchFormInputs } & HTMLAttributes<HTMLDivElement>> = ({
  searchObject,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const { depTime, destinationLabel, isRoundTrip, numPassengers, originLabel, returnTime } = explode(
    perpareSeachObjectChipValues(searchObject),
    {},
  );
  return (
    <div className="flex items-center gap-3 ">
      <div>
        <SearchIcon className="h-5 w-5 text-icon-subtle" strokeWidth={2} />
      </div>
      <div className={cn("@container flex w-full flex-1 flex-col gap-1", className)} {...props}>
        <div className="flex items-center font-medium justify-start gap-3 text-[clamp(.8rem,1cqw,2rem)]">
          <div>{originLabel}</div>
          <div className="text-font-active flex flex-col items-center justify-center">
            <NextArrowIcon className="h-3 w-3"/>
            {isRoundTrip && <BackArrowIcon className="h-3 w-3"/>}
          </div>
          <div>{destinationLabel}</div>
        </div>
        <div className="flex items-center gap-2 text-font-subtle text-[clamp(.7rem,1cqw,1.7rem)] font-inter">
          <div>
            <span className="font-semibold text-font-default">{depTime}</span>
            {isRoundTrip && <span className="font-semibold text-font-default"> - {returnTime}</span>}
          </div>
          <span className="text-font-minimal">|</span>
          <div className="flex items-center gap-1 font-medium">
            <PassengerIcon className="w-4 h-4" />
            <span>{numPassengers} {numPassengers === 1 ? t("Flights.search.passenger") : t("Flights.search.passengers")}</span>
          </div>
        </div>
      </div>
      <div>
        <EditIcon />
      </div>
    </div>
  );
};

export default JourneyChip;
